import React, { createContext, useContext, useState } from "react";

interface BookingModalContextType {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const BookingModalContext = createContext<BookingModalContextType | undefined>(
  undefined
);

export const useBookingModal = () => {
  const context = useContext(BookingModalContext);
  if (context === undefined) {
    throw new Error(
      "useBookingModal must be used within a BookingModalProvider"
    );
  }
  return context;
};

interface BookingModalProviderProps {
  children: React.ReactNode;
}

export const BookingModalProvider: React.FC<BookingModalProviderProps> = ({
  children,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <BookingModalContext.Provider
      value={{ isModalOpen, openModal, closeModal }}
    >
      {children}
    </BookingModalContext.Provider>
  );
};

export default BookingModalContext;
